/**
 * This is required because `setTimeout`'s internals only allow up to 2147483647 milliseconds since
 * timeout values too big to fit into a signed 32-bit integer may cause overflow in FF, Safari, and Chrome,
 * resulting in the timeout being scheduled immediately.
 *
 * https://nodejs.org/api/timers.html#settimeoutcallback-delay-args
 */
export const MAX_TIMEOUT_WAIT_IN_MS = 2147483647;
